import './App.css';
import Card from './components/Card';

function App() {
  return (
    <div className="app">
      <Card />
    </div>
  );
}

export default App;
